module.exports = __webpack_public_path__ + "img/SuccessTurtle3.94d99a31.gif";